module.exports = __webpack_public_path__ + "static/media/riskHeartFailure.c9ca09fb.mp3";